export const coachDemoUser = {
    id: 99,
    firstName: 'Maya',
    lastName: 'Kovac',
    image: '',
    bio: 'I coach athletes who want calm, precise progression in both pool and depth work. My focus is on repeatable structure, technical clarity, and training that translates into confidence in the water.',
    experimentalAiEnabled: true,
    aiGenerationEnabled: true,
    aiParameters: '{"trainee_level":"","personal_bests":{},"disciplines":[],"primary_discipline":"","cycle_start_date":null,"pool_schedule":[],"competition_targets":{},"coaching_notes":""}',
};

export const athleteDemoUser = {
    firstName: 'Lukas',
    lastName: 'Novak',
    completedTrainingsCount: 28,
    activeVariant: 202,
    coachSubscription: [
        {
            id: 1,
            variant_id: 202,
            name: 'Advanced Depth',
            first_name: 'Maya',
            last_name: 'Kovac',
        },
        {
            id: 2,
            variant_id: 203,
            name: 'Pool Technique',
            first_name: 'Tomas',
            last_name: 'Varga',
        },
    ],
};

export const coachDemoData = {
    trainingPlans: [
        { id: 101, name: 'Foundation Pool', description: 'A stable base plan for pool confidence, pacing, and repeatable technique.', agentDescription: '', private: false, shareCode: 'foundation-pool-demo' },
        { id: 102, name: 'Advanced Depth', description: 'Threshold work, longer breath-hold progressions, and recovery structure.', agentDescription: '', private: true, shareCode: 'advanced-depth-demo' },
        { id: 103, name: 'Competition Build', description: 'A focused cycle for sharpening execution before performance blocks.', agentDescription: '', private: true, shareCode: 'competition-build-demo' },
    ],
    selectedVariantId: '102',
    currentTraining: {
        id: 701,
        name: 'Week 6 Threshold Session',
        exercises: [
            { id: 1, category: 'Warmup', description: 'Mobility, breath-up, and easy lines' },
            { id: 2, category: 'Technique', description: 'Streamline and turn cleanup' },
            { id: 3, category: 'Main Set', description: 'Pacing ladder with recovery windows' },
            { id: 4, category: 'Cooldown', description: 'Light swim and decompression breathing' },
        ],
    },
    activity: [
        {
            userId: 1,
            firstName: 'Eva',
            lastName: 'Marek',
            variantName: 'Advanced Depth',
            completedTrainingModels: [
                { completed: 1, timestamp: '2026-03-27T08:20:00.000Z' },
                { completed: 1, timestamp: '2026-03-27T08:20:00.000Z' },
                { completed: 0, timestamp: '2026-03-27T08:20:00.000Z' },
            ],
        },
        {
            userId: 2,
            firstName: 'Nina',
            lastName: 'Bartos',
            variantName: 'Foundation Pool',
            completedTrainingModels: [
                { completed: 1, timestamp: '2026-03-26T17:05:00.000Z' },
                { completed: 1, timestamp: '2026-03-26T17:05:00.000Z' },
                { completed: 1, timestamp: '2026-03-26T17:05:00.000Z' },
            ],
        },
        {
            userId: 3,
            firstName: 'Adam',
            lastName: 'Horvat',
            variantName: 'Competition Build',
            completedTrainingModels: [
                { completed: 1, timestamp: '2026-03-25T12:40:00.000Z' },
                { completed: 0, timestamp: '2026-03-25T12:40:00.000Z' },
                { completed: 0, timestamp: '2026-03-25T12:40:00.000Z' },
            ],
        },
    ],
};

export const athleteDemoData = {
    hasCoachSubscription: true,
    nextTraining: {
        id: 900,
        name: 'Thursday Pool Session',
        exercises: [
            { id: 11, category: 'Warmup', description: '5 minute breath-up, easy finning, line prep' },
            { id: 12, category: 'A1', description: '4x 50m at controlled pace with 1:00 recovery' },
            { id: 13, category: 'A2', description: '3x 62.5m with recovery progression' },
            { id: 14, category: 'Cooldown', description: 'Easy loosen and breathing reset' },
        ],
    },
    history: [
        {
            timestamp: '2026-03-26T09:15:00.000Z',
            name: 'Threshold Builder',
            exerciseHistoryModels: [
                { completed: 1 },
                { completed: 1 },
                { completed: 0 },
            ],
        },
        {
            timestamp: '2026-03-24T18:10:00.000Z',
            name: 'Technique Reset',
            exerciseHistoryModels: [
                { completed: 1 },
                { completed: 1 },
                { completed: 1 },
            ],
        },
        {
            timestamp: '2026-03-22T10:40:00.000Z',
            name: 'Volume Day',
            exerciseHistoryModels: [
                { completed: 1 },
                { completed: 0 },
                { completed: 1 },
                { completed: 1 },
            ],
        },
    ],
};
